module.exports = __webpack_public_path__ + "static/media/SFProDisplay-Bold.42d79eba.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SFPro/TrueType/SFProDisplay-Bold.ttf
// module id = 2542
// module chunks = 7